# frozen_string_literal: true

module Engine
  class OptionError < RuntimeError
  end
end
